import clsx from 'clsx'
import styles from './MissingDisruptionInfo.module.scss'

interface Props {
    label: string
}

export const MissingDisruptionInfo = ({ label }: Props) => {
    return <p className={clsx(styles.text, styles.missing)}>Add {label}</p>
}
